(function () {
    'use strict';

    var tbody = document.getElementById('schedule-tbody');
    if (!tbody) return;

    var rows = tbody.querySelectorAll('tr[data-row-index]');
    var dragSourceIndex = null;
    var dragFields = null; // ドラッグ中の対象フィールド

    // 全フィールド（ユニットは移動対象外）
    var ALL_FIELDS = ['schedule', 'online_lesson_count', 'online_lesson_content', 'remarks'];

    // カラムごとのフィールド対応
    var COLUMN_FIELDS = {
        'all': ALL_FIELDS,
        'schedule': ['schedule'],
        'online_lesson_count': ['online_lesson_count'],
        'online_lesson_content': ['online_lesson_content'],
        'remarks': ['remarks']
    };

    /**
     * 行から指定フィールドの値を取得
     */
    function getRowValues(row, fields) {
        var dateKey = row.getAttribute('data-date-key');
        var values = {};
        fields.forEach(function (field) {
            var el = row.querySelector('[name="schedules[' + dateKey + '][' + field + ']"]');
            if (el) {
                values[field] = el.value;
            }
        });
        return values;
    }

    /**
     * 行に指定フィールドの値を設定
     */
    function setRowValues(row, values) {
        var dateKey = row.getAttribute('data-date-key');
        Object.keys(values).forEach(function (field) {
            var el = row.querySelector('[name="schedules[' + dateKey + '][' + field + ']"]');
            if (el && values[field] !== undefined) {
                el.value = values[field];
            }
        });
    }

    /**
     * チェックされた行のインデックスを取得（昇順）
     */
    function getCheckedIndices() {
        var indices = [];
        rows.forEach(function (row) {
            var cb = row.querySelector('.row-checkbox');
            if (cb && cb.checked) {
                indices.push(parseInt(row.getAttribute('data-row-index')));
            }
        });
        indices.sort(function (a, b) { return a - b; });
        return indices;
    }

    /**
     * 選択行の内容を指定位置に移動（挿入方式）
     */
    function moveRows(sourceIndices, targetIndex, fields) {
        if (sourceIndices.length === 0) return;

        var allRows = Array.from(rows);

        // 対象フィールドの値だけ全行から取得
        var allValues = allRows.map(function (row) {
            return getRowValues(row, fields);
        });

        // 移動元の値を取得
        var movedValues = sourceIndices.map(function (i) {
            return allValues[i];
        });

        // 移動元を除いた残りの値を取得
        var remainingValues = [];
        var remainingOriginalIndices = [];
        allValues.forEach(function (val, i) {
            if (sourceIndices.indexOf(i) === -1) {
                remainingValues.push(val);
                remainingOriginalIndices.push(i);
            }
        });

        // 挿入位置を計算
        // ドロップ先の行の位置に挿入する
        var insertPos = 0;
        var isMovingDown = sourceIndices[0] < targetIndex;

        for (var i = 0; i < remainingOriginalIndices.length; i++) {
            if (isMovingDown) {
                // 下方向に移動: ドロップ先の行の後ろに挿入
                if (remainingOriginalIndices[i] <= targetIndex) {
                    insertPos = i + 1;
                }
            } else {
                // 上方向に移動: ドロップ先の行の位置に挿入
                if (remainingOriginalIndices[i] < targetIndex) {
                    insertPos = i + 1;
                }
            }
        }

        // 挿入
        var newValues = remainingValues.slice(0, insertPos)
            .concat(movedValues)
            .concat(remainingValues.slice(insertPos));

        // 対象フィールドだけ全行に新しい値を設定
        allRows.forEach(function (row, i) {
            setRowValues(row, newValues[i]);
        });

        // 行チェック状態をリセット
        rows.forEach(function (row) {
            var cb = row.querySelector('.row-checkbox');
            if (cb) cb.checked = false;
        });
    }

    /**
     * ハイライトをクリア
     */
    function clearHighlight() {
        rows.forEach(function (r) {
            r.classList.remove('border-t-4', 'border-indigo-500', 'bg-indigo-100');
        });
    }

    var dragGhost = null; // カスタムドラッグ画像用の要素
    var activeHandle = null; // 現在ドラッグ中のハンドル

    // --- ドラッグ&ドロップ（各ハンドル共通） ---
    rows.forEach(function (row) {
        // 全ハンドル（行全体 + 各カラム）を取得
        var handles = row.querySelectorAll('.drag-handle');

        handles.forEach(function (handle) {
            handle.addEventListener('mousedown', function () {
                row.setAttribute('draggable', 'true');
                activeHandle = handle;
                // ドラッグ対象フィールドをハンドルのdata属性から取得
                var column = handle.getAttribute('data-drag-column') || 'all';
                dragFields = COLUMN_FIELDS[column] || ALL_FIELDS;
            });
        });

        row.addEventListener('dragstart', function (e) {
            dragSourceIndex = parseInt(row.getAttribute('data-row-index'));
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/plain', dragSourceIndex);

            var column = activeHandle ? activeHandle.getAttribute('data-drag-column') : 'all';

            if (column !== 'all') {
                // カラム個別ドラッグ: そのセルだけをゴースト画像にする
                var cell = activeHandle.closest('td');
                if (cell) {
                    dragGhost = cell.cloneNode(true);
                    dragGhost.style.position = 'absolute';
                    dragGhost.style.top = '-9999px';
                    dragGhost.style.left = '-9999px';
                    dragGhost.style.width = cell.offsetWidth + 'px';
                    dragGhost.style.backgroundColor = '#e0e7ff';
                    dragGhost.style.border = '2px solid #6366f1';
                    dragGhost.style.borderRadius = '4px';
                    dragGhost.style.padding = '4px';
                    dragGhost.style.opacity = '0.9';
                    document.body.appendChild(dragGhost);
                    e.dataTransfer.setDragImage(dragGhost, 20, 20);
                }
                // 該当セルだけ半透明に
                cell.classList.add('opacity-50');
            } else {
                // 一括ドラッグ: 移動対象のセル（スケジュール〜備考）だけ半透明に
                // ユニット・日付は動かさないので半透明にしない
                var cells = row.querySelectorAll('td.movable-cell');
                cells.forEach(function (c) { c.classList.add('opacity-50'); });

                // 対象セルだけでゴースト画像を作成
                dragGhost = document.createElement('div');
                dragGhost.style.position = 'absolute';
                dragGhost.style.top = '-9999px';
                dragGhost.style.left = '-9999px';
                dragGhost.style.display = 'flex';
                dragGhost.style.backgroundColor = '#e0e7ff';
                dragGhost.style.border = '2px solid #6366f1';
                dragGhost.style.borderRadius = '4px';
                dragGhost.style.padding = '4px';
                dragGhost.style.opacity = '0.9';
                dragGhost.style.gap = '2px';
                cells.forEach(function (c) {
                    var clone = c.cloneNode(true);
                    clone.style.width = c.offsetWidth + 'px';
                    dragGhost.appendChild(clone);
                });
                document.body.appendChild(dragGhost);
                e.dataTransfer.setDragImage(dragGhost, 20, 20);
            }
        });

        row.addEventListener('dragend', function () {
            row.setAttribute('draggable', 'false');
            // 全セルの半透明を解除
            row.classList.remove('opacity-50');
            row.querySelectorAll('td').forEach(function (c) {
                c.classList.remove('opacity-50');
            });
            // ゴースト要素を削除
            if (dragGhost) {
                document.body.removeChild(dragGhost);
                dragGhost = null;
            }
            dragSourceIndex = null;
            activeHandle = null;
            dragFields = null;
            clearHighlight();
        });

        row.addEventListener('dragover', function (e) {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            clearHighlight();
            row.classList.add('border-t-4', 'border-indigo-500', 'bg-indigo-100');
        });

        row.addEventListener('dragleave', function () {
            row.classList.remove('border-t-4', 'border-indigo-500', 'bg-indigo-100');
        });

        row.addEventListener('drop', function (e) {
            e.preventDefault();
            clearHighlight();

            var targetIndex = parseInt(row.getAttribute('data-row-index'));
            if (dragSourceIndex === null || dragSourceIndex === targetIndex) return;

            var fields = dragFields || ALL_FIELDS;

            // チェック行があればそれを一括移動（行全体ドラッグ時のみ）
            var checkedIndices = getCheckedIndices();
            var sourceIndices;
            if (checkedIndices.length > 0 && checkedIndices.indexOf(dragSourceIndex) !== -1) {
                sourceIndices = checkedIndices;
            } else {
                sourceIndices = [dragSourceIndex];
            }

            moveRows(sourceIndices, targetIndex, fields);
        });
    });

    // --- 全選択チェックボックス ---
    var selectAll = document.getElementById('select-all-rows');
    if (selectAll) {
        selectAll.addEventListener('change', function () {
            rows.forEach(function (row) {
                var cb = row.querySelector('.row-checkbox');
                if (cb) cb.checked = selectAll.checked;
            });
        });
    }
})();
